<template>
    <div>
        
        <table class="table">
            <thead>
                <tr>
                    <th class="hoverable" v-for="titleDat in titleData" @click="sortMe(titleDat.variable)">
                        {{ titleDat.title }}
                        <span v-if="filter.by == titleDat.variable">
                            <span v-if="filter.order == 'ASC'"> ▲</span>
                            <span v-else> ▼</span>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                </tr>
            </thead>    
            <tbody class="detailStockTable">
                <tr v-for="dat in data" v-if="data.length > 0">
                    <td v-for="titleDat in titleData">
                        {{ titleDat.number_formatting ? numberWithCommas(dat[titleDat.variable]) : dat[titleDat.variable] }}
                    </td>
                </tr>
                <tr v-else>
                    <td colspan="100%">
                        <p class="text-center pt-5 pb-5">No Data</p>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                dummyData : null,

                titleData : [
                    { title: "Type", variable:"type", number_formatting: false},
                    { title: "Color", variable:"color", number_formatting: false},
                    { title: "Gudang", variable:"gudang", number_formatting: false},
                    { title: "Inv MD to D", variable:"inv_md_to_d", number_formatting: true},
                    { title: "In-Transit MD to D", variable:"intransit_md_d", number_formatting: true},
                    { title: "Stock SSU", variable:"ssu", number_formatting: true},
                    { title: "Ready For Sales", variable:"ready_for_sales", number_formatting: true},
                    { title: "Not Ready For Sales", variable:"not_ready_for_sales", number_formatting: true},
                    { title: "DO Pending", variable:"pending_do", number_formatting: true},


                ]
            }
        },
        props : ['data', 'filter'],
        mounted () {
            // this.generateDummyData();
        },
        methods : {
            generateDummyData () {
                let dummy = [];

                let names = ['Beat', 'Scoopy', 'Beatstreet', 'ADV 150', 'Genio']
                for (var i = 0; i < 20; i++) {
                    let singleDummy = {
                        type : `Honda ${names[this.randomInt(0, 100)%names.length]} ${names[this.randomInt(0, 100)%names.length]}`,
                        color : 'All Color',
                        intransit : this.randomInt(0, 1000),
                        in : this.randomInt(0, 1000),
                        out : this.randomInt(0, 1000),
                        stockSSU : this.randomInt(0, 1000),
                        doPending : this.randomInt(0, 1000),
                        virtualStock : this.randomInt(0, 1000)
                    }
                    dummy.push(singleDummy);
                }

                this.dummyData = dummy;
            },
            sortMe (variable) {
                if (this.filter.by == variable)
                    this.filter.order = this.filter.order == 'ASC' ? 'DESC' : 'ASC';
                else {
                    this.filter.by = variable;
                    this.filter.order = 'DESC';
                }
            }
        }
    }
</script>

<style scoped>
    tbody {
        display: block;
        height: 400px;
        overflow-y: scroll;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
        width: calc(100% - 10px);
    }

    thead tr th {
        border-bottom: 0.5px solid #FF0009;
        font: normal normal 500 14px/16px Ubuntu;
        color: #707070;
    }

    tbody tr td {
        font: normal normal 500 13px/14px Ubuntu;
        color: #707070;
    }

    thead tr th,
    tbody tr td {
        vertical-align: middle;
    }

    .detailStockTable::-webkit-scrollbar{
        width:10px;
    }
    .detailStockTable::-webkit-scrollbar-track{
        background-color: white;
        border-radius: 20px;
    }
    .detailStockTable::-webkit-scrollbar-thumb{
        background-color: #F1F1F1;
        border-radius: 20px;
    }

    .hoverable {
        cursor: pointer;
    }
</style>
